(function () {
  const nav = document.getElementById("mkNav");
  if (!nav) return;

  const toggleBtn = document.getElementById("mkNavToggle");
  const closeBtn  = document.getElementById("mkNavClose");
  const drawer    = document.getElementById("mkNavDrawer");
  const backdrop  = document.getElementById("mkNavBackdrop");

  const navLinks = nav.querySelectorAll("[data-mk-nav-link]");
  const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function loadAnime() {
    if (window.anime) return Promise.resolve(window.anime);

    return new Promise((resolve) => {
      const existing = document.querySelector('script[data-contactegy-anime="1"]');
      if (existing) {
        existing.addEventListener("load", () => resolve(window.anime || null), { once: true });
        existing.addEventListener("error", () => resolve(null), { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/animejs@3.2.1/lib/anime.min.js";
      script.async = true;
      script.dataset.contactegyAnime = "1";
      script.onload = () => resolve(window.anime || null);
      script.onerror = () => resolve(null);
      document.head.appendChild(script);
    });
  }

  function setOpen(open) {
    nav.setAttribute("data-mk-open", open ? "true" : "false");

    if (toggleBtn) toggleBtn.setAttribute("aria-expanded", open ? "true" : "false");
    if (drawer) drawer.hidden = !open;
    if (backdrop) backdrop.hidden = !open;

    document.documentElement.style.overflow = open ? "hidden" : "";
    document.body.style.overflow = open ? "hidden" : "";
  }

  if (toggleBtn) {
    toggleBtn.addEventListener("click", function () {
      const isOpen = nav.getAttribute("data-mk-open") === "true";
      setOpen(!isOpen);
    });
  }

  if (closeBtn) closeBtn.addEventListener("click", () => setOpen(false));
  if (backdrop) backdrop.addEventListener("click", () => setOpen(false));

  navLinks.forEach((a) => a.addEventListener("click", () => setOpen(false)));

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") setOpen(false);
  });

  // تمييز الرابط الحالي
  const path = (window.location.pathname || "/").replace(/\/+$/, "") || "/";
  nav.querySelectorAll("a[data-mk-nav-link]").forEach((a) => {
    const href = (a.getAttribute("href") || "/").replace(/\/+$/, "") || "/";
    if (href === path) a.setAttribute("aria-current", "page");
    else a.removeAttribute("aria-current");
  });

  function handleScrollState() {
    if (window.scrollY > 8) nav.classList.add("mk-nav--scrolled");
    else nav.classList.remove("mk-nav--scrolled");
  }

  handleScrollState();
  window.addEventListener("scroll", handleScrollState, { passive: true });

  if (!reduceMotion) {
    loadAnime().then((anime) => {
      if (!anime) return;

      anime({
        targets: ".mk-nav__bar",
        opacity: [0, 1],
        translateY: [-16, 0],
        duration: 650,
        easing: "easeOutCubic",
      });

      anime({
        targets: ".mk-nav__link",
        opacity: [0, 1],
        translateY: [-8, 0],
        delay: anime.stagger(70),
        duration: 520,
        easing: "easeOutQuad",
      });

      nav.querySelectorAll(".mk-nav__link, .mk-nav__drawer-link").forEach((link) => {
        link.addEventListener("mouseenter", () => {
          anime.remove(link);
          anime({
            targets: link,
            scale: 1.04,
            duration: 180,
            easing: "easeOutQuad",
          });
        });
        link.addEventListener("mouseleave", () => {
          anime.remove(link);
          anime({
            targets: link,
            scale: 1,
            duration: 180,
            easing: "easeOutQuad",
          });
        });
      });
    });
  }

  setOpen(false);
})();